import { api } from "@/lib/api";
import type { ScopedParams } from "./common";
import type { LeaderboardRowDto, AchievementDto } from "@/types/api";

export const standingsApi = {
  leaderboard: ({ leagueId, tournamentId }: ScopedParams) =>
    api.get<LeaderboardRowDto[]>("/api/leaderboard", { leagueId, tournamentId }),
  achievements: ({ leagueId, tournamentId }: ScopedParams) =>
    api.get<AchievementDto[]>("/api/achievements", { leagueId, tournamentId }),
};
